import React, { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [ token, setToken ] = useState(null);
  const [email, setEmail ] = useState(null);

  useEffect(() => {
  const storedToken = localStorage.getItem("raptorid-token");
  const storedEmail = localStorage.getItem("raptorid-user-email");
  if (storedToken && storedToken !== token) setToken(storedToken);
  if (storedEmail && storedEmail !== email) setEmail(storedEmail);
 }, [token, email]);



  const login = (newToken, userEmail) => {
    localStorage.setItem("raptorid-token", newToken);
    localStorage.setItem("raptorid-user-email", userEmail);
    setToken(newToken);
    setEmail(userEmail);
  };

  const logout = () => {
    localStorage.removeItem("raptorid-token");
    localStorage.removeItem("raptorid-user-email");
    setToken(null);
    setEmail(null);
  };

  return (
    <AuthContext.Provider value={{ token, email, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
